import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { StoreSettLab } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';


const MxSettLabForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  let r_form = React.useRef(null);

  const [storeSettLab, setStoreSettLab] = useSessionStorage('StoreSettLab', StoreSettLab);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus==='error') {
    } else {
      storeSettLab.itLab = lastSaveRv.theValue;
      Promise.all([setStoreSettLab(storeSettLab)]).then((result) => {
        navBack();
      });
    }
  }
  const formDelete = async (rv) => {
  }

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.type')} - ${trans('field.lab')}`}
        xref={r_form}
        url="sett/lab" 
        filterIdField='itLab'
        filterIdValue={storeSettLab.itLab} 
        onFormLoad={formLoad} 
        onFormSave={formSave} 
        saveAndExit
        onFormDelete={formDelete} 
        >
        <CxHidden xref={useRef(null)} dbfield="t_lab.itLab" value={storeSettLab.itLab || ''} />
        <CxInput xref={useRef(null)} label={`${trans('field.type')} - ${trans('field.lab')}`} dbfield="t_lab.txTypeLab" required />
        
      </GxForm>

    </div>
  );

}

export default MxSettLabForm;
